<div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">{{"shared.noPermissions" | translate}}</h5>
          </div>
          <div class="card-body">
            <p class="card-text">{{"shared.noPermissionsDetail" | translate}}</p>
          </div>          
        </div>
      </div>
    </div>
  </div>
  